import HumanResoources from '@/models/system/human-resources.js'
import { commafy } from "common/js/util";
export default {
  data() {
    return {
      // 劳务公司集合
      laborServiceCompanyList: [],
    }
  },
  created() {
  },
  methods: {
    /** 
     * @desc 劳务公司集合
    */
    initLaborServiceCompanyList() {
      HumanResoources.getHumanResourcesList().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            obj.headName = value.contact;
            obj.phone = value.phone;
            obj.time = value.startTime;
            value.laborRuleList.map(j => {
              if (j.type === 1) {
                obj.cycleCopy = j.hourSalary;
                obj.cycle = commafy(j.hourSalary);
              } else if (j.type === 2) {
                obj.temporaryCopy = j.hourSalary;
                obj.temporary = commafy(j.hourSalary);
              } else {
                obj.longCycleCopy = j.hourSalary;
                obj.longCycle = commafy(j.hourSalary);
              }
            })
            arr.push(obj);
          });
          this.laborServiceCompanyList = arr;
        } else {
          this.$message.error(res.message)
        }
      });
    },
  }
}